module.exports = __webpack_public_path__ + "img/rainbow.f0f46c89.jpg";